import { ServiceNameType, ServiceNameTypeLabels } from '@consigli/types';

type FeedbackExportRow = {
  type: string;
  service: string | null;
  message: string;
  userEmail: string;
  createdAt: string;
};

const escapeCsvCell = (value: string) => `"${value.replace(/"/g, '""')}"`;

export const getServiceLabel = (service: string): string =>
  ServiceNameTypeLabels[service as ServiceNameType] ?? service;

export const buildFeedbackCsv = (rows: FeedbackExportRow[]) => {
  const header = ['Type', 'Skill', 'Message', 'User Email', 'Date'].map(escapeCsvCell).join(',');
  const dataRows = rows
    .map((row) => {
      const cells = [
        row.type,
        row.service ? getServiceLabel(row.service) : '-',
        row.message,
        row.userEmail,
        row.createdAt,
      ];
      return cells.map(escapeCsvCell).join(',');
    })
    .join('\n');

  return `\uFEFF${header}\n${dataRows}`;
};
